<div class="mr-2 mb-2">
  <span class="{{cssClass}} btn btn-sm btn-round">{{name}} &lt;{{email}}&gt;</span>
</div>
